/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdischedule.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edischedule";

export class AutogenModelEdischedule<RowType extends ModelRow> extends Endpoint<RowType, RowEdischeduleFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdischedule extends ModelRow<RowEdischeduleFields> {
	constructor(values?: Partial<RowEdischeduleFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdischeduleFields {
	alt_partner_id: string;
	company_id: string;
	frequency_per_hour: number;
	fri_0: string;
	fri_1: string;
	fri_10: string;
	fri_11: string;
	fri_12: string;
	fri_13: string;
	fri_14: string;
	fri_15: string;
	fri_16: string;
	fri_17: string;
	fri_18: string;
	fri_19: string;
	fri_2: string;
	fri_20: string;
	fri_21: string;
	fri_22: string;
	fri_23: string;
	fri_3: string;
	fri_4: string;
	fri_5: string;
	fri_6: string;
	fri_7: string;
	fri_8: string;
	fri_9: string;
	id: string;
	mon_0: string;
	mon_1: string;
	mon_10: string;
	mon_11: string;
	mon_12: string;
	mon_13: string;
	mon_14: string;
	mon_15: string;
	mon_16: string;
	mon_17: string;
	mon_18: string;
	mon_19: string;
	mon_2: string;
	mon_20: string;
	mon_21: string;
	mon_22: string;
	mon_23: string;
	mon_3: string;
	mon_4: string;
	mon_5: string;
	mon_6: string;
	mon_7: string;
	mon_8: string;
	mon_9: string;
	parent_row_id: string;
	parent_row_type: string;
	partner_id: string;
	sat_0: string;
	sat_1: string;
	sat_10: string;
	sat_11: string;
	sat_12: string;
	sat_13: string;
	sat_14: string;
	sat_15: string;
	sat_16: string;
	sat_17: string;
	sat_18: string;
	sat_19: string;
	sat_2: string;
	sat_20: string;
	sat_21: string;
	sat_22: string;
	sat_23: string;
	sat_3: string;
	sat_4: string;
	sat_5: string;
	sat_6: string;
	sat_7: string;
	sat_8: string;
	sat_9: string;
	start_min_in_hour: number;
	sun_0: string;
	sun_1: string;
	sun_10: string;
	sun_11: string;
	sun_12: string;
	sun_13: string;
	sun_14: string;
	sun_15: string;
	sun_16: string;
	sun_17: string;
	sun_18: string;
	sun_19: string;
	sun_2: string;
	sun_20: string;
	sun_21: string;
	sun_22: string;
	sun_23: string;
	sun_3: string;
	sun_4: string;
	sun_5: string;
	sun_6: string;
	sun_7: string;
	sun_8: string;
	sun_9: string;
	thu_0: string;
	thu_1: string;
	thu_10: string;
	thu_11: string;
	thu_12: string;
	thu_13: string;
	thu_14: string;
	thu_15: string;
	thu_16: string;
	thu_17: string;
	thu_18: string;
	thu_19: string;
	thu_2: string;
	thu_20: string;
	thu_21: string;
	thu_22: string;
	thu_23: string;
	thu_3: string;
	thu_4: string;
	thu_5: string;
	thu_6: string;
	thu_7: string;
	thu_8: string;
	thu_9: string;
	transaction_set: string;
	transaction_type: string;
	tue_0: string;
	tue_1: string;
	tue_10: string;
	tue_11: string;
	tue_12: string;
	tue_13: string;
	tue_14: string;
	tue_15: string;
	tue_16: string;
	tue_17: string;
	tue_18: string;
	tue_19: string;
	tue_2: string;
	tue_20: string;
	tue_21: string;
	tue_22: string;
	tue_23: string;
	tue_3: string;
	tue_4: string;
	tue_5: string;
	tue_6: string;
	tue_7: string;
	tue_8: string;
	tue_9: string;
	version: string;
	wed_0: string;
	wed_1: string;
	wed_10: string;
	wed_11: string;
	wed_12: string;
	wed_13: string;
	wed_14: string;
	wed_15: string;
	wed_16: string;
	wed_17: string;
	wed_18: string;
	wed_19: string;
	wed_2: string;
	wed_20: string;
	wed_21: string;
	wed_22: string;
	wed_23: string;
	wed_3: string;
	wed_4: string;
	wed_5: string;
	wed_6: string;
	wed_7: string;
	wed_8: string;
	wed_9: string;
}

